import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API } from "@/App";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Truck } from "lucide-react";
import { money } from "@/components/procurement/poUtils";

// Dashboard flag: supplier deliveries past their requested ETA.
export const OverdueDeliveriesCard = () => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  useEffect(() => { axios.get(`${API}/procurement/summary`).then(r => setData(r.data)).catch(() => {}); }, []);
  if (!data || data.overdue_count === 0) return null;
  const days = (d) => Math.max(1, Math.round((Date.now() - new Date(d + "T00:00:00").getTime()) / 86400000));
  return (
    <Card className="border-amber-300 bg-amber-50/40" data-testid="overdue-deliveries-card">
      <CardHeader className="pb-2"><CardTitle className="text-lg font-semibold flex items-center gap-2 text-amber-900"><Truck className="w-5 h-5" /> Late material deliveries <span className="text-sm font-normal text-amber-800">· {data.overdue_count} PO(s) past ETA</span></CardTitle></CardHeader>
      <CardContent className="divide-y">
        {data.overdue.map((p, idx) => (
          <div key={p.po_id} className="flex items-center justify-between py-2 gap-3 cursor-pointer hover:bg-white/60 -mx-2 px-2 rounded" onClick={() => navigate("/procurement")} data-testid={`overdue-delivery-row-${idx}`}>
            <div className="min-w-0"><p className="text-sm font-medium text-slate-900 truncate">{p.po_number} · {p.supplier_name}</p><p className="text-xs text-slate-500 truncate">{p.project_name || "Stock"} · ETA {p.expected_date}</p></div>
            <div className="flex items-center gap-2 shrink-0"><span className="text-sm font-semibold">{money(p.total)}</span><Badge className="bg-red-600 text-white">{days(p.expected_date)}d late</Badge></div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
